const styles = `@keyframes button-loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
::slotted(svg) {
  pointer-events: none;
}

:host {
  outline: none;
}
:host button {
  height: 2rem;
  width: 2rem;
  border-width: 1px;
  border-style: solid;
  border-radius: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: 0;
  flex: none;
  --goto-icon-color: var(--goto-icon-color-brand-default);
  --goto-icon-size: 1rem;
  color: var(--goto-icon-01);
  background-color: var(--goto-interactive-color-secondary-default);
  border-color: var(--goto-border-color-default);
  --goto-icon-color: var(--goto-icon-color-brand-default);
}
:host button:hover {
  background-color: var(--goto-interactive-color-secondary-hover);
  border-color: var(--goto-border-color-default);
}
:host button:active {
  background-color: var(--goto-interactive-color-secondary-pressed);
  border-color: var(--goto-border-color-default);
  box-shadow: none;
}
:host button:focus-visible {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
}
:host button:-moz-focusring {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
}

:host([variant=primary]) button {
  background-color: var(--goto-interactive-color-primary-default);
  border-color: var(--goto-interactive-color-primary-default);
  --goto-icon-color: var(--goto-icon-color-inverted);
}
:host([variant=primary]) button:hover {
  background-color: var(--goto-interactive-color-primary-hover);
  border-color: var(--goto-interactive-color-primary-hover);
}
:host([variant=primary]) button:active {
  background-color: var(--goto-interactive-color-primary-pressed);
  border-color: var(--goto-interactive-color-primary-pressed);
  box-shadow: none;
}
:host([variant=primary]) button:focus-visible {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
}
:host([variant=primary]) button:-moz-focusring {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
}

:host([variant=success]) button {
  background-color: var(--goto-interactive-color-success-default);
  border-color: var(--goto-interactive-color-success-default);
  --goto-icon-color: var(--goto-icon-color-inverted);
}
:host([variant=success]) button:hover {
  background-color: var(--goto-interactive-color-success-hover);
  border-color: var(--goto-interactive-color-success-hover);
}
:host([variant=success]) button:active {
  background-color: var(--goto-interactive-color-success-pressed);
  border-color: var(--goto-interactive-color-success-pressed);
  box-shadow: none;
}
:host([variant=success]) button:focus-visible {
  border-color: var(--goto-success-01);
  box-shadow: var(--goto-highlight-success);
}
:host([variant=success]) button:-moz-focusring {
  border-color: var(--goto-success-01);
  box-shadow: var(--goto-highlight-success);
}

:host([variant=danger]) button {
  background-color: var(--goto-interactive-color-danger-default);
  border-color: var(--goto-interactive-color-danger-default);
  --goto-icon-color: var(--goto-icon-color-inverted);
}
:host([variant=danger]) button:hover {
  background-color: var(--goto-interactive-color-danger-hover);
  border-color: var(--goto-interactive-color-danger-hover);
}
:host([variant=danger]) button:active {
  background-color: var(--goto-interactive-color-danger-pressed);
  border-color: var(--goto-interactive-color-danger-pressed);
  box-shadow: none;
}
:host([variant=danger]) button:focus-visible {
  border-color: var(--goto-danger-01);
  box-shadow: var(--goto-highlight-error);
}
:host([variant=danger]) button:-moz-focusring {
  border-color: var(--goto-danger-01);
  box-shadow: var(--goto-highlight-error);
}

:host([variant=primary].disabled:not([inactive])) button,
:host([variant=success].disabled:not([inactive])) button,
:host([variant=danger].disabled:not([inactive])) button {
  cursor: default;
  background-color: var(--goto-interactive-color-disabled);
  border-color: transparent;
  --goto-icon-color: var(--goto-icon-color-disabled);
  --goto-icon-color: var(--goto-icon-color-disabled);
}

:host([inactive]:not([disabled])) button {
  background-color: var(--goto-interactive-color-secondary-default);
  border-color: var(--goto-border-color-default);
  --goto-icon-color: var(--goto-icon-color-default);
}
:host([inactive]:not([disabled])) button:hover {
  background-color: var(--goto-interactive-color-secondary-hover);
  border-color: var(--goto-border-color-default);
}
:host([inactive]:not([disabled])) button:active {
  background-color: var(--goto-interactive-color-secondary-pressed);
  box-shadow: none;
  border-color: var(--goto-border-color-default);
}
:host([inactive]:not([disabled])) button:focus-visible {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
}
:host([inactive]:not([disabled])) button:-moz-focusring {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
}

:host([size=small]) button {
  height: 1.5rem;
  width: 1.5rem;
  --goto-icon-size: var(--goto-spacing-04);
}

:host([size=large]) button {
  height: 2.5rem;
  width: 2.5rem;
  --goto-icon-size: var(--goto-spacing-06);
}

:host([size=xlarge]) button {
  height: 3rem;
  width: 3rem;
  --goto-icon-size: var(--goto-spacing-06);
}

:host([size=xxlarge]) button {
  height: 3.5rem;
  width: 3.5rem;
  --goto-icon-size: var(--goto-spacing-07);
}

:host([disabled]) button {
  cursor: default;
  background-color: var(--goto-interactive-02);
  border-color: var(--goto-interactive-color-disabled);
  --goto-icon-color: var(--goto-icon-color-disabled);
}
:host([disabled]) button:hover {
  cursor: default;
  background-color: var(--goto-interactive-02);
  border-color: var(--goto-interactive-color-disabled);
  --goto-icon-color: var(--goto-icon-color-disabled);
}
:host([disabled]) .content {
  pointer-events: not-allowed;
}

:host .chameleon-loading-icon {
  display: none;
}

:host([is-loading]) .chameleon-loading-icon {
  display: flex;
  animation-delay: 0ms;
  animation-direction: normal;
  animation-duration: var(--goto-duration-sluggish);
  /* forwards, backwards, none, both */
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  /*Change it to paused if you have to 'paused' the animation*/
  animation-play-state: running;
  animation-timing-function: var(--goto-standard-easing);
  animation-name: button-loading;
}

:host([is-loading]:not([has-start-slot]):not([has-end-slot])) .content {
  display: none;
}

:host([is-loading]:is([has-start-slot])) .start {
  display: none;
}
:host([is-loading]:is([has-start-slot])) .chameleon-loading-icon {
  margin-right: 8px !important;
}

:host([is-loading]:is([has-end-slot])) .end {
  display: none;
}
:host([is-loading]:is([has-end-slot])) .chameleon-loading-icon {
  margin-left: 8px !important;
}`; export default styles;